// ----------------------------------------------------------------------------
// Section: Banner Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Script
import 'snippets/background-media/background-media';

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

// Styles
import './_banner-block.scss';

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);

    const bannerBlockSections = document.querySelectorAll('.banner-block');
    const tabletBreakPoint = 680;
    let resizeAnimationFrame;
    let isMobile = window.innerWidth <= tabletBreakPoint;

    function handleResize() {
        if (!resizeAnimationFrame) {
            resizeAnimationFrame = requestAnimationFrame(function() {
                isMobile = window.innerWidth <= tabletBreakPoint;
                
                const scrollTriggerInstances = gsap.utils.toArray(ScrollTrigger.getAll());

                scrollTriggerInstances.forEach((instance) => {
                    const parentNode = instance.trigger.parentNode;
                    
                    if (parentNode.classList.contains('banner-block')) {
                        const bannerBlockImage = parentNode.querySelector('.background-media');

                        if (isMobile) {
                            instance.disable();
                            bannerBlockImage.removeAttribute('style');
                            bannerBlockImage.style.width = '125%';
                        } else {
                            instance.enable();
                        }
                    }
                });

                resizeAnimationFrame = null;
            });
        }
    }

    if (bannerBlockSections) {
        bannerBlockSections.forEach((section) => {
            const bannerBlockImage = section.querySelector('.background-media');

            if (bannerBlockImage) {
                let scrollTriggerInstance;

                scrollTriggerInstance = ScrollTrigger.create({
                    trigger: bannerBlockImage,
                    start: 'top center',
                    end: 'bottom center',
                    scrub: true,
                    animation: gsap.fromTo(bannerBlockImage, {
                        width: window.innerWidth + 10,
                        borderRadius: 0,
                    }, 
                    {
                        width: '100%',
                        borderRadius: 20,
                    })
                });
        
                if (isMobile) {
                    scrollTriggerInstance.disable();
                    bannerBlockImage.style.width = '125%';
                }
            }
        });

        window.addEventListener('resize', handleResize);
    }
});